export default "__VITE_ASSET__C6NksrZe__"